// Currency utility functions and mappings

// Currency code to symbol mapping
export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  INR: '₹',
  CAD: 'C$',
  AUD: 'A$',
  CHF: 'CHF',
  CNY: '¥',
  SEK: 'kr',
  NOK: 'kr',
  MXN: '$',
  NZD: 'NZ$',
  SGD: 'S$',
  HKD: 'HK$',
  KRW: '₩',
  TRY: '₺',
  RUB: '₽',
  BRL: 'R$',
  ZAR: 'R',
  AED: 'د.إ',
  SAR: '﷼',
  QAR: 'ر.ق',
  OMR: 'ر.ع.',
  KWD: 'د.ك',
  BHD: '.د.ب',
};

// Currency code to locale mapping for formatting
export const CURRENCY_LOCALES = {
  USD: 'en-IN',
  EUR: 'de-DE',
  GBP: 'en-GB',
  JPY: 'ja-JP',
  INR: 'en-IN',
  CAD: 'en-CA',
  AUD: 'en-AU',
  CHF: 'de-CH',
  CNY: 'zh-CN',
  SEK: 'sv-SE',
  NOK: 'nb-NO',
  MXN: 'es-MX',
  NZD: 'en-NZ',
  SGD: 'en-SG',
  HKD: 'en-HK',
  KRW: 'ko-KR',
  TRY: 'tr-TR',
  RUB: 'ru-RU',
  BRL: 'pt-BR',
  ZAR: 'en-ZA',
  AED: 'ar-AE',
  SAR: 'ar-SA',
  QAR: 'ar-QA',
  OMR: 'ar-OM',
  KWD: 'ar-KW',
  BHD: 'ar-BH',
};

// Get currency symbol from currency code
export const getCurrencySymbol = (currencyCode = 'INR') => {
  return CURRENCY_SYMBOLS[currencyCode] || currencyCode;
};

// Format price with currency
export const formatPrice = (amount, currencyCode = 'INR') => {
  const symbol = getCurrencySymbol(currencyCode);
  const numericAmount = parseFloat(amount) || 0;
  
  // Format number with proper decimal places
  const formattedAmount = numericAmount.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  
  return `${symbol} ${formattedAmount}`;
};

// Get simple currency symbol for form inputs
export const getCurrencySymbolForInput = (currencyCode = 'INR') => {
  return getCurrencySymbol(currencyCode);
};

// Common currencies for dropdown selection (India-focused)
export const COMMON_CURRENCIES = [
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
];
